import type { BaseTheme } from "@glide/base-theme";
import type { defaultRuntimeTheme } from "./core-themes/runtime-theme";

export type RuntimeTheme = typeof defaultRuntimeTheme & BaseTheme;

export function isRuntimeTheme(theme: BaseTheme): theme is RuntimeTheme {
    return (theme as any).navBar?.style !== undefined;
}
